import { IDataPointMetricModel } from './model';

// Append the unit to a metric's name like a regular datapoint's presentName
// (`name, unit`); skip when the name already ends with it to avoid doubling
// (e.g. a diff of real datapoints whose names already carry the unit).
function withUnit(name: string, unit?: string) {
  return unit && !name.endsWith(`, ${unit}`) ? `${name}, ${unit}` : name;
}

export default (self: IDataPointMetricModel) => ({
  get presentName() {
    return withUnit(self.conditions.map((condition) => condition.presentName).join(' AND '), self.unit);
  },
  get shortPresentName() {
    return self.conditions.map((condition) => condition.shortPresentName).join(' AND ');
  },
  get data() {
    return self.measurements.map(([ts, value]) => (Array.isArray(value) ? [ts, value[0]] : [ts, value]));
  }
});
